import React from "react"
import styled from "styled-components"
import NextImg from "./NextImg"

interface ImageButtonProps {
  image: string
  href: string
  alt?: string
}

export default function ImageButton({ image, href, alt }: ImageButtonProps) {
  return (
    <a href={href} target="_blank" rel="noreferrer">
      <DownloadButton>
        <NextImg src={image} alt={alt ?? "Image button"} />
      </DownloadButton>
    </a>
  )
}

export const DownloadButton = styled.div`
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  width: 192px;
  max-width: 192px;
  min-height: 56px;
  height: auto;
  border-radius: 8px !important;
  &:focus,
  &:hover {
    transform: scale(1.05);
  }
  @media only screen and (max-width: 768px) {
    width: 200px;
    min-height: 58px;
    height: auto;
    border-radius: 8px;
  }
`
